import { render } from "./SavingsAccount.vue?vue&type=template&id=489b8ad9"
import script from "./SavingsAccount.vue?vue&type=script&lang=js"
export * from "./SavingsAccount.vue?vue&type=script&lang=js"

import "./SavingsAccount.vue?vue&type=style&index=0&id=489b8ad9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/SavingsAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "489b8ad9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('489b8ad9', __exports__)) {
    api.reload('489b8ad9', __exports__)
  }
  
  module.hot.accept("./SavingsAccount.vue?vue&type=template&id=489b8ad9", () => {
    api.rerender('489b8ad9', render)
  })

}


export default __exports__